module.exports = __webpack_public_path__ + "static/projectLocalties-dd134aed9151c928d8c5c4dffd7af6b0.png";